import type { AgencyStatusTone } from '@/modules/agencies/utils/agencyStatusTone'
import { cn } from '@/utils/cn'

export type AgencyStatusPillProps = {
  status: string
  tone: AgencyStatusTone
}

const toneClasses: Record<AgencyStatusTone, string> = {
  success: 'border-success bg-success-soft text-success',
  warning: 'border-warning bg-warning-soft text-warning',
  muted: 'border-line bg-paper text-muted',
}

export function AgencyStatusPill({ status, tone }: AgencyStatusPillProps) {
  return (
    <span
      className={cn(
        'inline-flex border-2 px-2 py-0.5 font-mono text-[0.68rem] uppercase tracking-[0.08em]',
        toneClasses[tone],
      )}
    >
      {status}
    </span>
  )
}
